module.exports = __webpack_public_path__ + "img/logo_reverberate.4acb5eb4.svg";